import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Col } from "react-bootstrap";
import React, { useState } from "react";

import { invoiceActions } from "../../../redux/actions/invoice.action";
import { serverFormatToDateString } from "../../../system";
import { ReceiptIcon } from "./../../../assets/images/icon";
import {
  paymentTypeConstants,
  timezoneConstants,
  translationConstants,
} from "../../../constants";

import ViewInvoiceLinks from "../Modals/ViewInvoiceLinks";

const InvoiceDetail = ({ paymentHistory, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [isShowModal, setShowModal] = useState(false);

  return (
    <div className="d-flex">
      <Col>
        <div className="font-14 invoice-column invoice-column-color d-flex align-items-center">
          {paymentHistory?.year}
        </div>
      </Col>
      <Col xs={7} sm={6} md={5} lg={4} xxl={3}>
        <div className="font-14 invoice-column invoice-column-color d-flex align-items-center">
          {t(
            translationConstants[
              paymentTypeConstants[paymentHistory?.paymentType]
            ]
          )}
        </div>
      </Col>
      <Col>
        <div className="font-14 invoice-column invoice-column-color d-flex align-items-center justify-content-center">
          {paymentHistory?.amount}
        </div>
      </Col>
      <Col>
        <div className="font-14 invoice-column invoice-column-color d-flex align-items-center">
          {serverFormatToDateString(
            paymentHistory?.timestampString,
            timezoneConstants.dayMonthYearFormat
          )}
        </div>
      </Col>
      <Col>
        <div className=" invoice-column invoice-column-color d-flex align-items-center">
          <img
            src={ReceiptIcon}
            alt="img-receipt"
            className="cursor-pointer"
            onClick={() => {
              dispatch(
                invoiceActions.getInvoice(paymentHistory?.id, () =>
                  setShowModal(true)
                )
              );
            }}
          />
        </div>
      </Col>

      <ViewInvoiceLinks isShowModal={isShowModal} setShowModal={setShowModal} />
    </div>
  );
};

export default InvoiceDetail;
